module.exports = __webpack_public_path__ + "img/oem.829410bf.png";